import { CommissionsSettingsRank, CreateUpdateCommissionsSettingsRank } from "./types";

export const convertCommissionsSettingsRankToCreateUpdateObject = (
  rank: CommissionsSettingsRank
): CreateUpdateCommissionsSettingsRank => {
  const { createdAt, updatedAt, id, formerRanks, nextRanks, ...data } = rank;

  return { ...data, nextRankIds: nextRanks.map(nextRank => nextRank.id) };
};
